/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduledTourCreateRequest } from '../../models/scheduled-tour-create-request';
import { Tour } from '../../models/tour';

export interface CreateScheduledTour$Params {
      body: ScheduledTourCreateRequest
}

export function createScheduledTour(http: HttpClient, rootUrl: string, params: CreateScheduledTour$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, createScheduledTour.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

createScheduledTour.PATH = '/api/v1/tours/scheduled';
